export function getColor(colorSeed) {
    const Yellow = { h: 50, s: 98, l: 57 } //#FDD924
    const Orange = { h: 35, s: 100, l: 56 } //#FFA21E
    const Green = { h: 85, s: 75, l: 51 } //#93E024
    const Blue = { h: 180.5, s: 57, l: 58 } //#59D0D1
    const Pink = { h: 349, s: 96, l: 78 } //#FD90A4
    const Colors = [Yellow, Orange, Green, Blue, Pink];

    const COLOR = Colors[Math.min(Colors.length - 1, Math.floor(colorSeed * Colors.length))];

    return COLOR;
}

export function getUserColor(colorSeed) {

    const COLOR = getColor(colorSeed);

    const userColor = {
        h: Math.max(0, COLOR.h - 4),
        s: COLOR.s,
        l: Math.max(0, COLOR.l - 6)
    };

    return userColor;

}

export function hsla(color, alpha) {
    return `hsla(${color.h}, ${color.s}%, ${color.l}%, ${alpha})`;
}

export function hexToRgb(hex) {

    try {

        let alpha = false,
            h = hex.slice(hex.startsWith('#') ? 1 : 0);
        if (h.length === 3) h = [...h].map(x => x + x).join('');
        else if (h.length === 8) alpha = true;
        h = parseInt(h, 16);
        return (
            'rgb' +
            (alpha ? 'a' : '') +
            '(' +
            (h >>> (alpha ? 24 : 16)) +
            ', ' +
            ((h & (alpha ? 0x00ff0000 : 0x00ff00)) >>> (alpha ? 16 : 8)) +
            ', ' +
            ((h & (alpha ? 0x0000ff00 : 0x0000ff)) >>> (alpha ? 8 : 0)) +
            (alpha ? `, ${h & 0x000000ff}` : '') +
            ')'
        );

    } catch (e) {
        console.error("Error parsing HEX to RGB : ", e);
        return null;

    }

};

export function rgbToHsl(r, g, b) {

    try {

        r /= 255;
        g /= 255;
        b /= 255;
        const l = Math.max(r, g, b);
        const s = l - Math.min(r, g, b);
        const h = s
            ? l === r
                ? (g - b) / s
                : l === g
                    ? 2 + (b - r) / s
                    : 4 + (r - g) / s
            : 0;
        return [
            60 * h < 0 ? 60 * h + 360 : 60 * h,
            100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
            (100 * (2 * l - s)) / 2,
        ];

    } catch (e) {
        console.error("Error parsing RGB to HSL : ", e)
        return null;

    }
   
};

export function hexToHsl(hex) {

    try {

        const rgb = hexToRgb(hex);

        const [r, g, b] = rgb
            .match(/\d+/g)
            .map(Number);

        const hsl = rgbToHsl(r, g, b);

        return hsl.map(value => Math.floor(value));

    } catch (e) {
        console.error("Error parsing HEX to HSL : ", e);
        return null;

    }


}

